<template>
  <Hoxton :revinate_token="revinate_token" :background_image="background_image" :template="template" :portal="portal" :connection_data="connection_data" @emitRegistrationMethodData="handleEmit" />
</template>

<script>
import Hoxton from '@/components/custom/hoxton/index'
export default {
  name: 'custom_template_hoxton_la',
  props: [ 'template', 'portal', 'connection_data' ],
  components: { Hoxton },
  data(){
    return{
      background_image: `https://sky-production.s3.amazonaws.com/brandportalimages/HoxtonBackground.jpeg`,
      revinate_token: 'f5615857-1538-47b0-b245-492b8cc03a47'
    }
  },
  methods: {
    handleEmit:function(data){
      this.$emit('emitRegistrationMethodData', data);
    }
  }
}
</script>
<style>
</style>
